var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.001 0c31.983 0 58.001 26.019 58.001 57.999 0 31.982-26.018 58.001-58 58.001C26.018 116 0 89.981 0 57.999 0 26.019 26.019 0 58.001 0zm0 8.948c-27.047 0-49.051 22.004-49.051 49.05 0 27.05 22.004 49.054 49.051 49.054S107.055 85.048 107.055 58c0-27.047-22.007-49.051-49.054-49.051zm1.443 32.296a5 5 0 0 1 5 5V87.8a5 5 0 0 1-5 5h-2.888a5 5 0 0 1-5-5V46.244a5 5 0 0 1 5-5h2.888zM58 23.2a6.444 6.444 0 1 1 0 12.889A6.444 6.444 0 0 1 58 23.2z",
    fill: "#79A1CD",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconInfo);
export default __webpack_public_path__ + "static/media/alert-icon-info.f6766dbc516a058fcba8e1acf5589029.svg";
export { ForwardRef as ReactComponent };